import useOAuth from 'hooks/useOAuth';
import { FC } from 'react';
import { Box, Button, Link } from 'roo-ui/components';

const OAuthLoginForm: FC = () => {
  const { login } = useOAuth();

  return (
    <Box mx={4}>
      <Button
        variant="primary"
        block
        onClick={() => {
          login();
        }}
        mb={4}
      >
        Login
      </Button>
      <Box>
        {`Not a member? You can `}
        <Link href="https://www.qantas.com/au/en/frequent-flyer/discover-and-join/join.html" target="_blank" rel="noreferrer">
          join here.
        </Link>
      </Box>
    </Box>
  );
};

export default OAuthLoginForm;
